var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Flower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 49v-4a11.32 11.32 0 0011.28-9.79V35h-.21A11.34 11.34 0 0040 41.82v-8.51A4.2 4.2 0 0042.22 30a4.27 4.27 0 006-6 4.25 4.25 0 000-8.45 4.26 4.26 0 00-6-6 4.26 4.26 0 00-8.47 0 4.26 4.26 0 00-6 6 4.27 4.27 0 000 8.48 4.24 4.24 0 00.31 5.66 4.28 4.28 0 005.67.33 4.23 4.23 0 002.27 3.3v11.82A11.32 11.32 0 0025.21 39H25v.21A11.33 11.33 0 0036 49v5H24l6.49 16h15L52 54H40v-5zm-2-24.23a5 5 0 110-10 5 5 0 010 10z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Flower.67b3d3e9.svg";
export { SvgE3Flower as ReactComponent };